export const phoneReg = /^1[3456789]\d{9}$/;//手机号正则

// export const emailReg = /^(?=.*@)(?=.*\.).*$/;//邮箱正则
export const emailReg = /./;//邮箱正则
